__webpack_require__.p = "/Stacks-Powered-Decentralized-Voting/";